import { saveDeal } from 'wallet-deals';

/**
 * saveDealFromLeadForm a new dealXgId if the deal is created/modified
 * saveDealFromLeadForm will not make the fetcher call if this listing is accelerate and a deal already exists
 * to perform a redux batch dispatch after sending an email
 */
export default async function saveDealFromLeadForm(_ref) {
  let {
    consumerBrand,
    enableSaveDeal,
    deal,
    isAccelerate,
    formData,
    dealXgId,
    listing,
    zip,
    walletId,
    isScheduleTestDrive,
    pixallId,
    saveDealXgFetcher,
    icoTradeIn,
    paymentsDuck,
    dealsDuck,
    dispatch,
    env
  } = _ref;
  if (dealsDuck) {
    await dispatch(dealsDuck?.creators?.removeHideReceiptListing({
      listingId: listing.id
    }));
  }
  if (enableSaveDeal && deal && (!isAccelerate || isAccelerate && !dealXgId)) {
    const isEsntial = listing.esntial && !listing.esntial?.deemphasized && !!Object.keys(listing.ecommWebsite).length;
    const phoneNumber = formData.phoneNumber && parseInt(formData.phoneNumber.replace(/\D+/g, ''), 10);
    const newDealXgId = await saveDeal({
      consumerBrand,
      icoTradeIn,
      formData,
      dealXgId,
      listing,
      deal,
      zip,
      walletId,
      phoneNumber,
      isScheduleTestDrive,
      componentName: 'ConnectedEmailOwner',
      saveDealXgFetcher,
      paymentsDuck,
      dealsDuck,
      pixallId,
      isEsntial,
      env
    });

    // newDealXgId will be the same one if there's an existing deal
    // when there is no existing deal, dealXgId is undefined, we need to save the deal and update dealXgId
    // update deals action is called when a new deal is created or to write Scheduled Test Drive status to wallet service/local storage
    const isNewDealXgId = newDealXgId && typeof newDealXgId === 'string';
    const shouldUpdateDeals = !dealXgId || newDealXgId !== dealXgId || isScheduleTestDrive;
    if (isNewDealXgId && shouldUpdateDeals) {
      return newDealXgId;
    }
  }
  return dealXgId;
}